/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContactResponseDto } from '../../models/sales-contact-response-dto';
import { SalesReferentCreateDto } from '../../models/sales-referent-create-dto';

export interface ContactsControllerAddReferent$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the contact.
 */
  id: string;
      body: SalesReferentCreateDto
}

export function contactsControllerAddReferent(http: HttpClient, rootUrl: string, params: ContactsControllerAddReferent$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContactResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contactsControllerAddReferent.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContactResponseDto>;
    })
  );
}

contactsControllerAddReferent.PATH = '/o2-sales/contacts/{tenant}/{id}/referents';
